import {useMemo} from 'react';
import {useCurrentAuthTokens} from '../../../auth';
import {decodeJwtToken} from '../../../auth/functions';
import {UserInfo} from './types';

export const useUserInfo = () => {
  const tokens = useCurrentAuthTokens();
  const userInfo = useMemo(
    () => (tokens ? decodeJwtToken<UserInfo>(tokens.accessToken) : undefined),
    [tokens],
  );

  return userInfo;
};

export * from './types';
